"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateCollection = exports.createOption = exports.components = void 0;
var React = __importStar(require("react"));
var creatable_1 = __importDefault(require("react-select/creatable"));
var Context_1 = require("./Context");
var remote_1 = require("../../../remote");
var ModalWrapper_1 = require("../../common/ModalWrapper");
exports.components = {
    DropdownIndicator: null
};
exports.createOption = function (label, options, values) {
    var found = options === null || options === void 0 ? void 0 : options.find(function (o) { return o.label === label; });
    var foundValues = values === null || values === void 0 ? void 0 : values.find(function (v) { return v.label === label; });
    if (found || foundValues)
        return;
    return {
        label: label,
        value: label
    };
};
var useContext = React.useContext, useState = React.useState;
exports.CreateCollection = function (props) {
    var ctx = useContext(Context_1.ArtworkContext);
    var setIsReload = ctx.setIsReload, isModalOpen = ctx.isModalOpen, selected = ctx.selected, collections = ctx.collections, handleToggleModal = ctx.handleToggleModal;
    var _a = useState(""), inputValue = _a[0], setInputValue = _a[1];
    var _b = useState(false), isSubmitting = _b[0], setIsSubmitting = _b[1];
    var _c = useState([]), newCollections = _c[0], setNewCollections = _c[1];
    var _d = useState(""), errorMessage = _d[0], setErrorMessage = _d[1];
    var _e = useState(""), warningMessage = _e[0], setWarningMessage = _e[1];
    var handleChange = function (value, action) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, setNewCollections(value)];
    }); }); };
    var handleKeyDown = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var newOption;
        return __generator(this, function (_a) {
            if (inputValue)
                switch (e.key) {
                    case "Enter":
                    case "Tab":
                        newOption = exports.createOption(inputValue, collections, newCollections);
                        if (newOption) {
                            setNewCollections(__spreadArrays(newCollections, [newOption]));
                        }
                        setInputValue("");
                        e.preventDefault();
                    case "Backspace":
                        if (inputValue.length === 1) {
                            setInputValue("");
                        }
                }
            return [2 /*return*/];
        });
    }); };
    var handleCreate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, all, ids_1, resSelect, res_1, resSelect, e_1, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // if (!newCollections?.length) {
                    //   setWarningMessage('Please enter a collection name and press "Enter" or "Tab"')
                    //   return
                    // }
                    setIsSubmitting(true);
                    setErrorMessage("");
                    setWarningMessage("");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 8, , 9]);
                    if (!(newCollections === null || newCollections === void 0 ? void 0 : newCollections.length)) return [3 /*break*/, 4];
                    res = newCollections === null || newCollections === void 0 ? void 0 : newCollections.map(function (c) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, remote_1.createArtworkLibraryCollection(c.label)];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    }); }); });
                    return [4 /*yield*/, Promise.all(res)];
                case 2:
                    all = _a.sent();
                    setIsReload(function (prev) { return (__assign(__assign({}, prev), { collections: true, artwork: true })); });
                    ids_1 = all === null || all === void 0 ? void 0 : all.map(function (a) { return a.data._id; });
                    resSelect = selected === null || selected === void 0 ? void 0 : selected.map(function (s) { return __awaiter(void 0, void 0, void 0, function () {
                        var collections;
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    collections = (_a = s === null || s === void 0 ? void 0 : s.collections) === null || _a === void 0 ? void 0 : _a.map(function (c) { return c._id; });
                                    return [4 /*yield*/, remote_1.updateArtworkLibrary(s, __spreadArrays((collections || []), (ids_1 || [])))];
                                case 1:
                                    _b.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(resSelect)];
                case 3:
                    _a.sent();
                    setNewCollections([]);
                    handleToggleModal("createCollection");
                    return [2 /*return*/];
                case 4:
                    if (!inputValue) return [3 /*break*/, 7];
                    return [4 /*yield*/, remote_1.createArtworkLibraryCollection(inputValue)];
                case 5:
                    res_1 = _a.sent();
                    resSelect = selected === null || selected === void 0 ? void 0 : selected.map(function (s) { return __awaiter(void 0, void 0, void 0, function () {
                        var collections;
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    collections = (_a = s === null || s === void 0 ? void 0 : s.collections) === null || _a === void 0 ? void 0 : _a.map(function (c) { return c._id; });
                                    return [4 /*yield*/, remote_1.updateArtworkLibrary(s, __spreadArrays((collections || []), [
                                            (_b = res_1 === null || res_1 === void 0 ? void 0 : res_1.data) === null || _b === void 0 ? void 0 : _b._id
                                        ]))];
                                case 1:
                                    _c.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(resSelect)];
                case 6:
                    _a.sent();
                    setIsReload(function (prev) { return (__assign(__assign({}, prev), { collections: true, artwork: true })); });
                    setInputValue("");
                    handleToggleModal("createCollection");
                    _a.label = 7;
                case 7: return [3 /*break*/, 9];
                case 8:
                    e_1 = _a.sent();
                    errMsg = (e_1 === null || e_1 === void 0 ? void 0 : e_1.code) < 500
                        ? e_1.message
                        : "We are experiencing technical difficulties. Please try again";
                    setErrorMessage(errMsg);
                    return [3 /*break*/, 9];
                case 9:
                    setIsSubmitting(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleInputchange = function (e) {
        if (e) {
            setInputValue(e);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalWrapper_1.ModalWrapper, { isOpen: true, onClose: function () { return handleToggleModal("createCollection"); }, style: { maxWidth: "450px" } },
            React.createElement("h3", { className: "text-center" }, "Create New Collection"),
            React.createElement("div", { className: "rounded-corner p-3 p-md-4 bg-white mb-3" },
                React.createElement(creatable_1.default, { isSearchable: true, isMulti: true, isClearable: true, isLoading: isSubmitting, isDisabled: isSubmitting, inputValue: inputValue, components: exports.components, menuIsOpen: false, onKeyDown: handleKeyDown, onChange: handleChange, onInputChange: handleInputchange, placeholder: 'Type something and press "Enter" or "Tab"...', value: newCollections }),
                warningMessage && (React.createElement("div", { className: "alert alert-warning mt-3" }, warningMessage)),
                errorMessage && (React.createElement("div", { className: "alert alert-danger mt-3" }, errorMessage)),
                React.createElement("div", { className: "mt-3 text-center" },
                    React.createElement("button", { type: "button", disabled: isSubmitting, className: "btn btn-pink", onClick: handleCreate }, "Create"))))));
};
